import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[appTableTemplate]',
    standalone: false,
})
export class AppTableTemplateDirective {
    @Input('appTableTemplate') name = '';

    constructor(public readonly template: TemplateRef<unknown>) {}
}

